export default __webpack_public_path__ + "static/media/bkg.84e99ddc.png";